import { DropdownMenu } from '@ksyos/design-system';
import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';

export function createServiceOptions(
    services: ServiceForSelectedServiceType[] | undefined,
    onClickSubService: (name: string, service: ServiceForSelectedServiceType) => void,
    service: ServiceForSelectedServiceType
) {
    return services
        ?.sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => (
            <DropdownMenu.Item
                key={item.code}
                onClick={() => {
                    onClickSubService(item.code, { ...service });
                }}
            >
                {item.name}
            </DropdownMenu.Item>
        ));
}
